export default function About() {
  const stats = [
    { number: '500+', label: 'Clientes satisfechos' },
    { number: '3', label: 'Regiones principales' },
    { number: '48hrs', label: 'Tiempo promedio de despacho' },
    { number: '100%', label: 'Compromiso con calidad' }
  ];

  return (
    <section id="nosotros" className="py-20 relative bg-[#5D4037]">
      <div className="absolute inset-0 opacity-10">
        <div className="w-full h-full" style={{ backgroundImage: 'url("data:image/svg+xml,%3Csvg width=\'60\' height=\'60\' viewBox=\'0 0 60 60\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cg fill=\'none\' fill-rule=\'evenodd\'%3E%3Cg fill=\'%23ffffff\' fill-opacity=\'1\'%3E%3Cpath d=\'M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z\'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")', backgroundSize: '60px 60px' }}></div>
      </div>

      <div className="relative z-10 max-w-5xl mx-auto px-6 text-center">
        <div className="inline-block bg-[#D4AF37] text-white px-6 py-2 rounded-full text-sm font-bold mb-6">
          MÁS DE 20 AÑOS
        </div>
        
        <h2 className="text-5xl font-serif font-bold text-[#F5E6D3] mb-8 leading-tight">
          Experiencia que Respalda Cada Proyecto
        </h2>
        
        <p className="text-lg text-white leading-relaxed mb-16 max-w-4xl mx-auto" style={{ lineHeight: '1.8' }}>
          Empresa familiar con trayectoria comprobada en el mercado maderero chileno. Atendemos desde particulares hasta grandes proyectos, combinando tradición, conocimiento técnico y atención moderna. Nuestro compromiso: madera de calidad, precios justos y entregas cumplidas.
        </p>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
          {stats.map((stat, index) => (
            <div key={index} className="text-center">
              <div className="text-5xl font-bold text-[#D4AF37] mb-2 font-serif">
                {stat.number}
              </div>
              <p className="text-white text-sm">
                {stat.label}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
